import { Component, OnInit } from '@angular/core';
import { HealthService } from 'src/app/services/health.service';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';


@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.css']
})
export class HealthComponent implements OnInit {
  dateTimeFilterArray: any = {};

  healthlycount = {'periodic': '', 'nonperiodic': ''};

  healthArray: any[] = this.healthService.healthArray;

  constructor(private healthService: HealthService, private datepipe: DateFormatPipe) {

    this.dateTimeFilterArray = this.healthService.setFilterParam();

   }

  ngOnInit() {
  this.runHealthCheck();
  //   /*call this function every 2 mins */
  //   setTimeout(() => {
  //     this.runHealthCheck();
  // }, 120000);
    }

  runHealthCheck() {
     this.dateTimeFilterArray = this.healthService.setFilterParam();
    // this.getPeriodicAndNonperiodicPoll();
    // this.totalHealthCountOfEachState();
  }



totalHealthCountOfEachState() {
  // this.healthService.getHealthResult(this.dateTimeFilterArray.filterparam)
  // .subscribe(data => {
  //   this.healthArray.forEach(function(health, index) {
  //       health.value = data[index];
  //      // console.log(health.value);
  //     });
  //     // console.log("final healthArray"+JSON.stringify(this.healthArray));
  // });

}


  getPeriodicAndNonperiodicPoll() {
  //   this.healthService.getHealthcount(this.dateTimeFilterArray.filterparam)
  //   .subscribe(data => {
  //     this.healthlycount.periodic = data[0];
  //     this.healthlycount.nonperiodic = data[1];
  //   });

  // }
}










}

